const moment = require('moment');

function isWeekend(date) {
    const isoWeekday = date.isoWeekday();
    return isoWeekday === 5 || isoWeekday === 6;
}

function subtractBusinessDays(date, days) {
    const result = moment(date);
    let remaining = days;

    while (remaining > 0) {
        result.subtract(1, 'day');
        if (!isWeekend(result)) {
            remaining -= 1;
        }
    }

    return result;
}

function countBusinessDaysUntil(date) {
    const target = moment(date).startOf('day');
    const cursor = moment().startOf('day');
    let count = 0;

    while (cursor.isBefore(target)) {
        cursor.add(1, 'day');
        if (!isWeekend(cursor)) {
            count += 1;
        }
    }

    return count;
}

module.exports = {
    isWeekend,
    subtractBusinessDays,
    countBusinessDaysUntil,
};
